<template>
  <v-container fluid>
    <!--BEGIN SDKs-->
    <v-container>
      <v-row class="mx-auto mt-10">
        <h1 class="mx-auto">We have a lot more for you...</h1>
      </v-row>
      <v-card flat class="text--white mt-2" id="plugins">
        <v-row>
          <v-col cols="12" md="6" class="text--primary mt-10">
            <div>
              <v-card-text>
                <h3 class="text--primary text-uppercase">PLUGINS</h3>
                <div class="mt-3">SasaPay has official Plugins for your seamless integrations:</div>

                <div class="mt-3">Do you have online shops/e-commerce platforms and wondering how to collect payments? Worry no more.</div>
              </v-card-text>

              <v-divider class="mx-4"></v-divider>
            </div>
            <div class="mt-10">
              <v-card-title>Supported Platforms</v-card-title>
              <v-card-text>
                <v-row>
                  <v-col cols="12" md="4" sm="6">
                    <v-avatar size="30" @click="redirect">
                      <v-img src="@/assets/sp/wordpress.png"/>
                    </v-avatar>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-avatar size="30">
                      <v-img src="@/assets/sp/joomla.png"/>
                    </v-avatar>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-img src="@/assets/sp/opencart.png"/>
                  </v-col>
                </v-row>
              </v-card-text>
            </div>
          </v-col>

          <v-col cols="12" md="6">
            <v-img src="@/assets/sp/plugins.png"/>
          </v-col>
        </v-row>
      </v-card>
      <!--languages-->
      <v-card flat class="text--white" id="sdk">
        <v-divider/>
        <v-row>
          <v-col cols="12" md="6">
            <v-img src="@/assets/sp/coder.png"/>
          </v-col>
          <v-col cols="12" md="6" class="text--primary mt-10">
            <div>
              <v-card-text>
                <h3 class="text--primary text-uppercase">SDKs</h3>
                <div class="mt-3">SasaPay has official SDKs for different programming languages:</div>

                <div class="mt-3">Try our SDKs to streamline the integration experience.</div>
              </v-card-text>

              <v-divider class="mx-4"></v-divider>
            </div>
            <div class="mt-10">
              <v-card-title>Supported Languages/Frameworks</v-card-title>
              <v-card-text>
                <v-row>
                  <v-col cols="12" md="3">
                    <v-icon x-large color="primary">mdi-language-php</v-icon>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-icon x-large color="error">mdi-language-java</v-icon>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-icon x-large color="warning">mdi-language-python</v-icon>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-icon x-large color="secondary">mdi-nodejs</v-icon>
                  </v-col>
                </v-row>
              </v-card-text>
            </div>
          </v-col>
        </v-row>
      </v-card>

      <!--event-->
      <v-card flat class="text--white" id="events">
        <v-row>
          <v-col cols="12" md="6" class="text--primary mt-10">
            <div>
              <v-card-text>
                <h3 class="text--primary text-uppercase">Event Notifications</h3>
                <div class="mt-3">SasaPay has an event handler</div>

                <div class="mt-3">Stay informed of API transaction events with our notification tools.</div>
              </v-card-text>

              <v-divider class="mx-4"></v-divider>
            </div>
            <div class="mt-10">
              <v-card-title>We currently support</v-card-title>
              <v-card-text>
                <v-chip-group
                    active-class="deep-purple accent-4 white--text"
                    column
                >
<!--                  <v-chip class="primary" @click="redirect" outlined>Instant Payment Notification (IPN)</v-chip>-->
                  <v-chip class="primary" @click="redirect" outlined>Webhooks</v-chip>
                </v-chip-group>
              </v-card-text>
            </div>
          </v-col>

          <v-col cols="12" md="6">
            <v-img src="@/assets/sp/event.png"/>
          </v-col>
        </v-row>
      </v-card>
      <!--event-->
    </v-container>
    <!--END SDKs-->
  </v-container>
</template>

<script>
export default {
  name: "SDK",
  data: () => ({
    replace: [
      { from: "SasaPay ensures seamless connectivity across different platforms including financial institutions, fitness and retail outlets among others", to: "We allow for payment of goods and services, transfer of money and more hustle free" },
    ],
  }),
  methods: {
    onSignUp(){
      window.open('https://merchant.sasapay.app/','_blank')
    },
    redirect(){
      window.open("https://github.com/sasapay/sasapay-woocommerce-plugin",'_blank')
    }
  }
}
</script>